// extracted by mini-css-extract-plugin
export default {"cards":"CardAsignature_cards__AwceA","nombreMateria":"CardAsignature_nombreMateria__a9mpz"};